import MainCarousel from '../components/MainCarousel'

const Carousel = () => {
    return (
      <div>
            <MainCarousel />
      </div>
    );
  };
  
  export default Carousel;